<template>
  <div v-if="siteHeader" class="header-area">
    <div @click="handleClickOnHeader" :class="['header', {'clickable': currentPage !== 'home'}]">
      <div v-if="siteHeader.image" class="header-image">
        <img :src="siteHeader.image.url" />
      </div>
      <div class="header-text">
        <div v-if="siteHeader.sitename" class="header-sitename">
          <h2>{{siteHeader.sitename}}</h2>
        </div>
        <div v-if="siteHeader.tagline" class="header-tagline">
          <h3>{{siteHeader.tagline}}</h3>
        </div>
      </div>
    </div>
    <TopMenu v-if="siteHeader.topMenu" :id="siteHeader.topMenu.id" slug="top-menu" />
    <SocialBar v-if="siteHeader.socialBar" :id="siteHeader.socialBar.id" className="social-bar" />
  </div>
</template>

<script>

import TopMenu from 'components/Menu.vue'
import SocialBar from 'components/Social.vue'

import gql from 'graphql-tag'

export default {
  name: 'Header',
  props: [
    'id',
    'currentPage'
  ],
  data() {
    return {
      siteHeader: {}
    }
  },
  components: {
    TopMenu,
    SocialBar
  },
  apollo: {
    siteHeader: {
      query: gql`query SiteHeader ($id: ItemId) {
        siteHeader (filter: {id: {eq: $id}}) {
          tagline
          sitename
          image { url }
          topMenu {
            id
          }
          socialBar {
            id
          }
        }
      }`,
      variables() {
        return {
          id: this.id
        }
      },
      prefetch({route}) {
        return {
          id: route.params.id
        }
      }
    }
  },
  methods: {
    handleClickOnHeader() {
      if (this.currentPage !== 'home') {
        this.$router.push({ name: 'home' });
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/assets/styles/breakpoints.less";

.header-area {
  margin-bottom: 40px;
  background-color: #FFFFFF;
  display: flex;
  flex-wrap: wrap;
  padding: 10px;

  & /deep/ .social-bar {
    width: 100%;
    display: flex;
    line-height: 20px;

    & .social-bar-item {
      flex: 1;
      display: flex;
      padding: 0 10px;

      & .social-bar-label {
        margin-right: 10px;
        font-weight: bold;
      }

      & .social-bar-value {
        display: flex;

        & a {
          color: #006699;
          text-transform: none;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }

        & .social-bar-value-item {
          & a {
            margin: 0 2px;
            height: 20px;
            width: 20px;
            display: block;
            text-indent: -9000px;
            background-repeat: no-repeat;
          }
        }
      }
    }
  }

  & /deep/ .top-menu {
    display: flex;

    & .top-menu-item {
      margin-left: 20px;

      & a {
        color: #959595;
        display: block;
        padding: 0;
        text-transform: uppercase;
        text-decoration: none;
        font-family: 'LeagueGothicRegular',Helvetica,sans-serif;
        font-size: 24px;
        line-height: 24px;

        &:hover {
          color: #0F0F0F;
        }

        &.router-link-active {
          color: #0F0F0F;
        }
      }
    }
  }

  & .header {
    flex: 1;
    display: flex;

    &.clickable {
      cursor: pointer;
    }

    & .header-image {
      margin-right: 10px;
    }

    & .header-sitename {
      font-family: LeagueGothicRegular,Arial,sans-serif;
      font-size: 400%;
      line-height: 98px;
      height: 78px;
      text-transform: uppercase;

      & h2 {
        padding: 0;
        margin: 0;
      }
    }

    & .header-tagline {
      font-family: Helvetica,Arial,sans-serif;
      font-size: 75%;
      line-height: 20px;
      height: 20px;
      text-transform: none;
      color: #9C9C9C;
      text-align: right;

      & h3 {
        padding: 0;
        margin: 0;
      }
    }
  }
}

@media @for-phone {
  .header-area {
    & .top-menu {
      flex-direction: column;
    }

    & .social-bar {
      flex-direction: column;
    }

    & .header {
      & .header-sitename {
        font-size: 200%;
      }
      & .header-tagline {
        display: none;
      }
    }
  }
}
</style>
